/**
 * The report right justifies numbers and left justifies text. A value counts as a
 * number when it reads as a quantity: a plain figure, currency or percentage, with
 * or without a trailing unit such as "96 hours" or "$ 990.00 / day". Dates, tier
 * names and anything else opening with a word stay text.
 */
const NUMERIC_VALUE =
  /^\(?\s*-?\s*\$?\s*\d[\d,]*(\.\d+)?\s*(%|[A-Za-z/][A-Za-z/. ]{0,11})?\s*\)?$/;

export const isNumericValue = (value) =>
  value !== null && value !== undefined && NUMERIC_VALUE.test(String(value).trim());

/** Justification modifier for a rendered value; React nodes fall back to text. */
export const alignClass = (value) => {
  const isRenderable = typeof value === "string" || typeof value === "number";
  return isRenderable && isNumericValue(value) ? "ces-num" : "ces-txt";
};
